import React, { useEffect, useState } from 'react';
import userimg from '../../Assets/imgNewUI/user-placeholder.png';
import { useDispatch, useSelector } from 'react-redux';
import PointBalance from '../PointBalance/pointBalance';
import NewCardSection from '../NewCardSection/NewCardSection';
import getTranslation from '../../TranslationUtility/TranslationUtility';
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import API from "../../Common/Endpoint/serviceConstrants";
import { ApiConfigData, MyAccountSectionMasterData, SectionMasterData, UtilityReducer } from '../../Utility/Utility';
import { onSaveIamge, onSetApiError, onUpdatePointBalance } from '../../Store/Slices/utilityReducer';
import MyActivity from '../RewardPoint/MyActivity';
import { onGetVoucherHistory } from '../../Store/Slices/voucherHistorySlice';
import HelpSupport from '../RewardPoint/HelpSupport'; import GetSectionByType from '../../HomePage/GetSectionByType';

import { onGetMyAccountSection } from '../../Store/Slices/myAccountPageSlice';
import CustomBackHeader from '../../Utility/CustomBackHeader/CustomBackHeader';
import ScrollToTop from '../../Utility/ScrollToTop/ScrollToTop';
import { useNavigate } from 'react-router-dom';
import arrowDownIcon from "../../Assets/img/arrow-down.svg";
import AccountCardSection from '../NewCardSection/AccountCardSection';

const MyAccount = ({ login, setIsLoading, setShowModal, Loading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [historyMenu, setHistoryMenu] = useState(false);
    const [helpSupportMenu, setHelpSupportMenu] = useState(false);
    const memberDataReducer = useSelector((state) => state.getMemberSliceReducer);
    const memberData = memberDataReducer?.MemberData?.memberProfile;
    const userName = memberData?.firstName + " " + memberData?.lastName;
    const Layout1 = memberData?.firstName + " " + memberData?.lastName?.[0] || "";
    const Layout2 = memberData?.firstName + " " + memberData?.lastName;
    const Layout3 = ((memberData?.firstName?.[0] || "N") + (memberData?.lastName?.[0] || "A")).toUpperCase();
    const generateToken = useSelector((state) => state.generateTokenSliceReducer);
    const translation = getTranslation();
    const [selectedCard, setSelectedCard] = useState(null);
    const [cardLoader, setCardLoader] = useState(false);
    const loginToken = useSelector(
        (state) => state.validateLoginTokenSliceReducer
    );
    const apiconfig = ApiConfigData();
    const [modalOpen, setModalOpen] = useState(false);
    const card = UtilityReducer();
    const [loading, setLoading] = useState(false);
    const switchAccountEnable = apiconfig?.find(
        (data) => data?.paramsKey === "switchAccountEnable"
    )?.paramsValue;

    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
    const { isMyAccountSectionLoading, myAccountsectionMasterData } = MyAccountSectionMasterData(login);
    const { sectionMasterData } = SectionMasterData(login);

    useEffect(() => {
        window.addEventListener("resize", () => { setIsMobileView(window.innerWidth <= 769); });
        return () => {
            window.removeEventListener("resize", () => { setIsMobileView(window.innerWidth <= 769); });
        };
    }, []);

    // Remove overflow:hidden from body when modalOpen changes
    useEffect(() => {
        if (modalOpen || helpSupportMenu) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [modalOpen, helpSupportMenu]);

    let headerSection = sectionMasterData?.filter((section) => section?.sectionType === translation?.homePageHeader);

    useEffect(() => {
        if (!headerSection?.length || headerSection.some((sec) => sec?.headerSectionType === "NONE")) {
            return navigate(-1);//navigate back to home page if there is no header section
        }
        // Find the object with valueIndetifier === 'CardDetails'
        const cardDetailsObj = loginToken?.data?.otherListAttribute?.find(
            (item) => item?.valueIndetifier === "CardDetails"
        );
        const cardCodeValue = [
            ...new Set(
                cardDetailsObj?.valueDetails
                    ?.filter(card => card.status === "1" || card.status === "2")
                    ?.map(card => card.CardTypeName?.toLowerCase()).filter(Boolean)
            )
        ] || [];
        // cardsNetwork isn't consumed by eligibility logic yet, but sending it now for a future use case.
        const cardsNetwork = [
            ...new Set(
                cardDetailsObj?.valueDetails
                    ?.filter(card => card.status === "1" || card.status === "2")
                    ?.map(card => card.Network?.toLowerCase()).filter(Boolean)
            )
        ] || [];
        dispatch(onGetMyAccountSection({
            memberIdentifier: loginToken?.data?.memberIdentifier,
            cardCode: encodeURIComponent(cardCodeValue.join(", ")),
            cardsNetwork: encodeURIComponent(cardsNetwork.join(", ")),
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const totalPointBalance = card?.totalPointBalance === 0 ? 0 : card?.totalPointBalance;
    const creditCards = card?.creditCards?.filter((card => card.status === "1"));
    const partnerCode = apiconfig?.find(
        (data) => data?.paramsKey === "partnerCode"
    )?.paramsValue;
    const clientCode = apiconfig?.find(
        (data) => data?.paramsKey === "clientCode"
    )?.paramsValue;
    const autoSelect = sessionStorage.getItem("autoSelect");
    if (!login) {
        return <div>Please log in to view your account.</div>;
    }

    const callSwitchAccountApi = async (
        payload,
        cardData,
        isApiCall,
        defaultCard,
        homePage
    ) => {
        if (!generateToken?.data?.accessToken) {
            console.error("Access token is missing");
            return;
        }

        axiosIntegration.defaults.headers["access-token"] =
            generateToken.data.accessToken;

        const updateCardData = (card, balanceData, error = false) => ({
            ...card,
            pointBalance: error ? undefined : balanceData?.pointBalance,
            totalPointBalance: error
                ? card.totalPointBalance
                : balanceData?.totalPointBalance,
            showTryAgain: error,
            showViewPoint: false,
        });

        const saveImageData = (balanceData, error = false) => ({
            currentPoints: error ? undefined : balanceData?.pointBalance,
            totalPointBalance: error
                ? cardData?.totalPointBalance
                : balanceData?.totalPointBalance,
            currentBg: cardData?.backgroundcolor,
            cardName: cardData?.CardTypeName,
            showTryAgain: error,
            showViewPoint: false,
        });

        try {
            if (switchAccountEnable === "1") { setLoading(true); }
            else {
                setLoading(false);
            }

            const { data = {} } = await axiosIntegration.post(
                API.switchAccountApi,
                payload,
                {
                    headers: { clientCode, partnerCode },
                }
            );

            const balanceData = data?.response?.memberBalance;

            const updatedCards = creditCards?.map((card) =>
                card.identifier === data?.response?.subIdentifier
                    ? updateCardData(card, balanceData)
                    : card
            );

            let total = Math.floor(updatedCards?.reduce((acc, card) => {
                if (typeof card.pointBalance === "number" && card.pointBalance > 0) {
                    return acc + card.pointBalance;
                }
                return acc;
            }, 0));
            const hasUndefined = updatedCards?.some(card => typeof card.pointBalance !== "number");
            if (hasUndefined) {
                total = translation?.myAccount;
            }
            dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards, totalPointBalance: total }));

            if (!isApiCall || defaultCard || homePage) {
                dispatch(onSaveIamge(saveImageData(balanceData)));
                if (defaultCard || homePage) setModalOpen(false);
            }

            dispatch(onSetApiError(false));
        } catch (error) {
            console.error("Error switching account:", error);

            const updatedCards = creditCards?.map((card) =>
                card.identifier === payload?.subIdentifier
                    ? updateCardData(card, null, true)
                    : card
            );

            dispatch(onSetApiError(true));
            dispatch(onUpdatePointBalance({ updatedCreditCards: updatedCards, totalPointBalance: translation?.myAccount }));

            if (!isApiCall) {
                dispatch(onSaveIamge(saveImageData(null, true)));
            }
        } finally {
            setLoading(false);
            if (!isApiCall) setModalOpen(false);
        }
    };
    const selectCard = async (
        index,
        type,
        card,
        isApiCall,
        defaultCard,
        homePage
    ) => {
        const cardInfo = { index, type, card };
        !isApiCall && setSelectedCard(cardInfo);
        !isApiCall && sessionStorage.setItem("selectedCard", JSON.stringify(cardInfo));
        const payload = {
            identifier: loginToken?.data?.memberIdentifier,
            subIdentifier: card?.identifier,
            identifierType: parseInt(card?.identifiertype),
            userSessionToken: sessionStorage.getItem("loginSessionToken"),
            isAccountSwitch: isApiCall ? false : true,
        };
        setCardLoader(true);
        setTimeout(() => {
            setCardLoader(false);
        }, 2000);
        if (autoSelect || isApiCall) {
            try {
                await callSwitchAccountApi(
                    payload,
                    card,
                    isApiCall,
                    defaultCard,
                    homePage
                );
            } catch (error) { }
        }
    };


    // Get myActivityString safely
    const myActivityString = apiconfig?.find(
        (data) => data?.paramsKey === "myactivity"
    )?.paramsValue;

    // Parse myActivityString safely, fallback to [] if not found or invalid
    let myActivityData = [];
    if (myActivityString) {
        try {
            myActivityData = JSON.parse(myActivityString);
            if (!Array.isArray(myActivityData)) myActivityData = [];
        } catch (e) {
            myActivityData = [];
        }
    }

    const helpSupportString = apiconfig?.find(
        (data) => data?.paramsKey === "helpsupport"
    )?.paramsValue;

    let helpSupportData = [];
    try {
        if (helpSupportString) {
            helpSupportData = JSON.parse(helpSupportString);
            helpSupportData?.sort((a, b) => a.order - b.order);
        }
    } catch (err) {
        console.error('Error parsing helpSupportData:', err);
        helpSupportData = [];
    }

    const myAccountString = apiconfig?.find(
        (data) => data?.paramsKey === "myaccount"
    )?.paramsValue;

    let myAccountData = {};

    try {
        if (typeof myAccountString === "string") {
            myAccountData = JSON.parse(myAccountString);
        } else if (typeof myAccountString === "object" && myAccountString !== null) {
            myAccountData = myAccountString;
        }
    } catch (err) {
        console.error("❌ JSON parse error:", err, myAccountString);
        myAccountData = {};
    }

    // Check if any credit card has undefined pointBalance
    const hasUndefinedPointBalance = creditCards && creditCards.some(card => typeof card.pointBalance !== "number");

    return (
        <>{!(!headerSection?.length || headerSection.some((sec) => sec?.headerSectionType === "NONE")) && <>
            {isMobileView && <CustomBackHeader
                title={""}
                isTransperent={true}
            />}
            <div className='myaccount-bg'>
                <ScrollToTop />
                <div className='imgwrapper'>
                    <img className='userimg' src={userimg} alt="My Account Background" />
                </div>
                <div className='profile-card'>
                    <div className='name'>
                        {myAccountData?.ProfileTextLayout === "Layout1" ? Layout1 :
                            myAccountData?.ProfileTextLayout === "Layout3" ? Layout3 : Layout2}
                    </div>
                    {creditCards && creditCards.length > 0 && !hasUndefinedPointBalance && (typeof totalPointBalance === "number" || totalPointBalance?.toLowerCase() !== translation?.myAccount?.toLowerCase()) && (
                        <PointBalance isMyAccount={true} />
                    )}
                    {/* {translation?.totalRewardsPoints && <span className="total-rewards-points">{translation?.totalRewardsPoints || "Total Rewards Points"}</span>} */}
                    {myAccountData?.CardSectionConfiguration && creditCards && creditCards.length > 0 && (
                        <>
                            <hr className='mt-5 mb-5' />
                            <AccountCardSection title={translation.YourProducts} selectCard={selectCard} selectedCard={selectedCard} cardLoader={cardLoader} isOpen={modalOpen} setIsOpen={setModalOpen} loading={loading} />
                            {/* <hr className='mt-5 mb-5' />
                            <NewCardSection title={translation.YourProducts} selectCard={selectCard} selectedCard={selectedCard} cardLoader={cardLoader} isOpen={modalOpen} setIsOpen={setModalOpen} loading={loading} /> */}
                        </>
                    )}

                </div>
                {myActivityData && myActivityData.length > 0 && (
                    <div className='my-activity' onClick={() => setHistoryMenu(true)}>
                        <div className='head'>
                            <h3>{translation?.myActivity}</h3>
                            <p>{translation?.myActivitySubhead}</p>
                        </div>
                        <hr className='actispe' />
                        <MyActivity
                            login={login}
                            setShowModal={setShowModal}
                            apiconfig={apiconfig}
                            setIsLoading={setIsLoading}
                            Loading={Loading}
                            title={translation?.myActivity}
                            onClose={() => setHistoryMenu()}
                            isOpen={historyMenu}
                        />
                        {/* <i className="fa fa-angle-right" aria-hidden="true"></i> */}
                    </div>
                )}
                {helpSupportData && helpSupportData.length > 0 && <div
                    className="help-support flex items-center justify-between"
                    onClick={() => setHelpSupportMenu(true)}
                >
                    <h3>{translation?.helpSupport}</h3>
                    {/* <i className="fa fa-angle-right" aria-hidden="true"></i> */}
                    <img
                        src={arrowDownIcon}
                        alt="Arrow Icon"
                    />
                </div>}
                {login && !isMyAccountSectionLoading && myAccountsectionMasterData?.map((sectionData, index) => (
                    <div className={isMobileView && login ? "animation-section" : ""} key={index}>
                        <GetSectionByType
                            sectionData={sectionData}
                            isLogin={login}
                            setIsLoading={setIsLoading}
                            Loading={Loading}
                            isMobileView={isMobileView}
                            isMyAccountPage={true}
                        />
                    </div>
                ))}
            </div>
            {helpSupportMenu && (
                <>
                    <HelpSupport
                        title={translation?.helpSupport}
                        onClose={() => setHelpSupportMenu()}
                        isOpen={helpSupportMenu}
                    />
                </>
            )}
        </>
        }</>
    );
};

export default MyAccount;